import React, { useEffect, useState } from 'react';

import { classNames } from '@/helpers/classNames';
import { useDarkMode } from '@/hooks/useDarkMode';
import { DatumId, MayHaveLabel, ResponsivePie } from '@nivo/pie';
import { useTimeoutFn } from 'react-use';

import styles from './PieChart.module.scss';

export type RadialBarChartData = {
	id: DatumId;
	value: number;
	color: string;
	label?: string | number;
}[];

export type PieChartProps = {
	data: RadialBarChartData;
	wrapperClassName?: string;
	animationDelay?: number;
};

export const PieChart: React.FC<PieChartProps> = ({
	data: originalData,
	wrapperClassName,
	animationDelay,
}) => {
	const { isDarkModeOn } = useDarkMode();
	const [animationComplete, setAnimationComplete] = useState(false);
	// Needed for the initial animation
	// It will assign the data with y: 0 for all data fields
	// and when the useTimeoutFn runs it will set it to the initial values
	const [data, setData] = useState<RadialBarChartData>(
		originalData.map((idObj) => ({
			...idObj,
			value: 0,
		})),
	);
	// Second part of the animation logic
	useTimeoutFn(() => {
		setData(originalData);
		setAnimationComplete(true);
	}, animationDelay || 200);

	useEffect(() => {
		if (animationComplete) {
			setData(originalData);
		}
	}, [originalData, animationComplete]);

	return (
		<div className={wrapperClassName}>
			<ResponsivePie
				data={data}
				enableArcLinkLabels={false}
				enableArcLabels={false}
				// padding={0.2}
				innerRadius={0.65}
				isInteractive={false}
				colors={{
					datum: 'data.color',
				}}
				// cornerRadius={45}
				// colors={['#d2dff9', '#ddff95', '#f9aea1', '#beb1d8']}
			/>
		</div>
	);
};
